'use strict';

angular.module('TurneroApp').component('coAtenciontelefonica', {
    bindings: {
        usuario: '<'
    },
    controller: ['$window', 'tramiteService', '$rootScope',
        function ($window, tramiteService, $rootScope) {
            var ctrl = this;

            ctrl.limpiarMemoria = function () {
                $rootScope.$broadcast('esHome', false);
                $rootScope.$broadcast('esCalendario', false);
                $rootScope.$broadcast('esTasaRetributiva', false);
            }

            ctrl.$onInit = function () {
                ctrl.limpiarMemoria();
                ctrl.obtenerTramites();
            };

            ctrl.obtenerTramites = function () {
                tramiteService.Get_Telefonicos(function (resultado) {
                    ctrl.Tramites = resultado.Data;

                    if (ctrl.Tramites.length > 0) {
                        ctrl.cargarArray();
                    }

                })
            }

            ctrl.cargarArray = function () {
                ctrl.TramitesArray = []
                var obj = {};
                for (var i = 0; i < ctrl.Tramites.length; i++) {
                    if (obj.Telefono == ctrl.Tramites[i].Telefono) {
                        obj.Tramites.push({ 'N_Tramite': ctrl.Tramites[i].N_Tramite, 'Url': ctrl.Tramites[i].Url })
                    } else if (i != 0) {
                        ctrl.TramitesArray.push(obj)
                        obj = {}
                        obj.Tramites = [];
                        obj.Tramites.push({ 'N_Tramite': ctrl.Tramites[i].N_Tramite, 'Url': ctrl.Tramites[i].Url })
                        obj.Telefono = ctrl.Tramites[i].Telefono;
                    } else {
                        obj.Tramites = [];
                        obj.Tramites.push({ 'N_Tramite': ctrl.Tramites[i].N_Tramite, 'Url': ctrl.Tramites[i].Url })
                        obj.Telefono = ctrl.Tramites[i].Telefono;
                    }
                }
                ctrl.TramitesArray.push(obj)
                ctrl.TramitesArray;

            }



            //array hardcoded for testing
    //        ctrl.Tramites = [];
    //        ctrl.Tramites = [{
    //            N_Tramite: 'ASESORAMIENTO NUEVAS HERRAMIENTAS AUTOGESTIÓN -AUTORIZACIÓN SOLICITUD DE LICENCIAS, LISTADO DE AUSENTISMOS Y LISTADO DE PEDIDOS DE CARPETAS MEDICAS',
    //            Telefono: '0800-4444222',
    //            Url: 'http://portaldetramites.cba.gov.ar/v/1684'
    //        }
    //        , {
    //            N_Tramite: 'MAB ELECTRONICO - CUPOF DEL SUPLENTE MAL ASIGNADO',
    //            Telefono: '0800-4444222',
    //            Url: 'http://portaldetramites.cba.gov.ar/v/1512'
    //        },
    //{
    //    N_Tramite: 'MAB ELECTRONICO - DIFICULTAD PARA GENERAR UNA NOVEDAD',
    //    Telefono: '0800-4444222',
    //    Url: 'http://portaldetramites.cba.gov.ar/v/1511'
    //},
    //{
    //    N_Tramite: 'MAB ELECTRONICO - MAB PROCESADO SIN LIQUIDAR',
    //    Telefono: '0800-4444222',
    //    Url: 'http://portaldetramites.cba.gov.ar/v/1515'
    //},
    //{
    //    N_Tramite: 'MAB ELECTRONICO - MAB RECHAZADOS',
    //    Telefono: '0800-4444222',
    //    Url: 'http://portaldetramites.cba.gov.ar/v/1516'
    //},
    //{
    //    N_Tramite: 'MAB ELECTRONICO - MAB SIN PROCESAR',
    //    Telefono: '0800-4444800',
    //    Url: 'http://portaldetramites.cba.gov.ar/v/1509'
    //},
    //{
    //    N_Tramite: 'REUBICACIÓN POR CAMBIO DE PLAN DE ESTUDIO - DIPE BLANQUEO',
    //    Telefono: '0800-4444800',
    //    Url: 'http://portaldetramites.cba.gov.ar/v/1513'
    //},
    //{
    //    N_Tramite: 'REUBICACIÓN POR CAMBIO DE PLAN DE ESTUDIO - DIPE INCREMENTO',
    //    Telefono: '0800-4444800',
    //    Url: 'http://portaldetramites.cba.gov.ar/v/1514'
    //},
    //{
    //    N_Tramite: 'REUBICACIÓN POR CAMBIO DE PLAN DE ESTUDIO - ESTABLECIMIENTOS PÚBLICOS',
    //    Telefono: '0800-4444800',
    //    Url: 'http://portaldetramites.cba.gov.ar/v/1510'
    //}]

        }],
    template: require('./atencionTelefonica.html')

});





// WEBPACK FOOTER //
// ./app/components/turnos/turnosOnline/atencionTelefonicaComponent.js